// Test-only 'rowing detected' light: visible only while a stroke sensor log is recording.
import { useEffect, useState } from 'react';
import { getActiveSensorLog } from '@/lib/strokeSensorLogger';

export const RowingDetectedLight = () => {
  const [recording, setRecording] = useState(() => !!getActiveSensorLog());
  const [detected, setDetected] = useState(false);

  useEffect(() => {
    const onLog = (e) => setRecording(!!e.detail?.recording);
    const onDetector = (e) => setDetected(!!e.detail?.open);
    window.addEventListener('crewz-sensor-log-state', onLog);
    window.addEventListener('crewz-rowing-detector', onDetector);
    return () => {
      window.removeEventListener('crewz-sensor-log-state', onLog);
      window.removeEventListener('crewz-rowing-detector', onDetector);
    };
  }, []);

  if (!recording) return null;
  return (
    <div
      className="fixed top-16 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-zinc-900/85 text-white text-[10px] font-bold tracking-wide pointer-events-none"
      data-testid="rowing-detected-light"
      data-detected={detected ? 'true' : 'false'}
    >
      <span className={`w-2.5 h-2.5 rounded-full transition-colors duration-200 ${detected ? 'bg-green-500' : 'bg-zinc-500'}`} />
      {detected ? 'ROWING DETECTED' : 'NO ROWING DETECTED'}
    </div>
  );
};
